import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import api from "../lib/api";
import { Loader2 } from "lucide-react";

const MANDATORY = ["name", "position", "company", "phone"];

function missingFields(profile) {
    return MANDATORY.filter((k) => !((profile?.[k] || "").trim?.() || profile?.[k]));
}

export default function MyCard() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/profile/me");
                const missing = missingFields(data);
                if (missing.length) {
                    navigate(`/profile?required=${missing.join(",")}`, { replace: true });
                    return;
                }
                const identifier = data.card_slug || data.user_id;
                if (identifier) {
                    // Open the public card in a new tab so the user can see it
                    // as anyone with the link would. Replace history so back
                    // doesn't loop.
                    window.location.replace(`/c/${identifier}`);
                    return;
                }
                setLoading(false);
            } catch {
                setLoading(false);
            }
        })();
    }, [navigate]);

    return (
        <Layout title="Mi tarjeta digital" subtitle="Abriendo tu tarjeta...">
            <div className="py-16 flex items-center justify-center text-slate-400 text-sm" data-testid="my-card-page">
                {loading ? (
                    <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Cargando tu tarjeta...</>
                ) : (
                    <span>No se pudo cargar tu tarjeta.</span>
                )}
            </div>
        </Layout>
    );
}
